import { combineEpics, ofType } from "redux-observable";
import { setCountyList, setCountySelected, setStateList, setStateSelected } from "../../../store/calculation/calculation-input/ProjectTabSlice";
import { map, mergeMap, switchMap, withLatestFrom, from, of, debounceTime } from "rxjs";
import useProjectTabFacade from "../../../facade/calculation/calculation-input/projectTab.Facade";
import useProjectFacade from "../../../facade/project.Facade";
import { CustomerDetailsPayload, WellDetailsPayload } from "../../../store/model/calculations/calculation";

const getStateList = (action$: any, state$: any) =>
    action$.pipe(
        ofType('projectTab/setCountrySelected'),
        withLatestFrom(ofType('calculations/getProjectDetails')),
        switchMap(([action, state]) => {
            const countryId = state?.country;
            return from(useProjectTabFacade().getStatesByCountry()).pipe(
                map((data: any) => Object.assign({}, ...data.map((x: any) => ({ [x.stateName]: x.stateID })))),

                mergeMap(stateList => [
                    setStateSelected('0'),
                    setStateList({ payload: stateList }),
                ]),
            );
        })
    );

const getCountyList = (action$: any, state$: any) =>
    action$.pipe(
        ofType('projectTab/setStateSelected'),
        withLatestFrom(ofType('calculations/getProjectDetails')),
        switchMap(([actionData, tab4Input]) => {
            if (tab4Input.state !== "0") {
                return from(useProjectTabFacade()?.getCountyByState(tab4Input?.state)).pipe(
                    map(data => {
                        if (JSON.stringify(data) !== JSON.stringify({ Other: '-1' })) {
                            return { data };
                        }
                        return { data };
                    }),
                    mergeMap(data => [
                        setCountyList({ data }),
                        setCountySelected("0")
                    ]),
                );
            } else {
                const empty = Object.assign({});
                return of(1).pipe(
                    mergeMap(() => [
                        setCountyList({ payload: empty }),
                        setCountySelected('0'),
                    ])
                );
            }
        })
    );


const getCountryByState = (action$: any, state$: any) =>
    action$.pipe(
        ofType('projectTab/setStateSelected'),
        withLatestFrom(ofType('calculations/getProjectDetails')),
        switchMap(([actionData, tab4Input]) => {
            if (tab4Input.state !== "0") {
                return from(useProjectTabFacade()?.getCountyByState(tab4Input?.state)).pipe(
                    map(data => {
                        if (JSON.stringify(data) !== JSON.stringify({ Other: '-1' })) {
                            return { data };
                        }
                        return { data };
                    }),
                    mergeMap(data => [
                        setCountyList({ data }),
                        setCountySelected("0")
                    ]),
                );
            } else {
                const empty = Object.assign({});
                return of(1).pipe(
                    mergeMap(() => [
                        setCountyList({ payload: empty }),
                        setCountySelected('0'),
                    ])
                );
            }
        })
    );

const getWellDetailsList = (action$: any) =>
    action$.pipe(
        ofType("connexia-cNXWell/gettingWellDeatils"),
        debounceTime(500),
        switchMap((actionData: WellDetailsPayload) => {
            return from(useProjectFacade().loadWellDetailsList(actionData)).pipe(
                map((details) => (details))
            );
        })
    );

const getCustomerDetailsList = (action$: any) =>
    action$.pipe(
        ofType("connexia-cNXCustomer/gettingCustomerDetails"),
        debounceTime(500),
        switchMap((actionData: CustomerDetailsPayload) => {
            return from(useProjectFacade().loadCustomerDetailsList(actionData)).pipe(
                map((details) => (details))
            );
        })
    );

const getWellDetailsById = (action$: any) =>
    action$.pipe(
        ofType("connexia-CNXWellsById/gettingWellDetailsById"),
        debounceTime(500),
        switchMap((actionData: number) => {
            return from(useProjectFacade().loadWellDeatilsById(actionData)).pipe(
                map((details) => (details))
            );
        })
    );

export const projectTabEpic = combineEpics(
    getStateList,
    getCountyList,
    getWellDetailsList,
    getCustomerDetailsList,
    getWellDetailsById,
    getCountryByState,
)